import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

// Redux type and action creators
const { Types, Creators } = createActions({
  mouseChanged: ['event'],
  reset: []
})

export const MouseTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  lngLat: {}
})

// Redux reducers
export const mouseChanged = (state, { event }) => {
  const { lngLat } = event
  return state.merge({ lngLat })
}

export const reset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.MOUSE_CHANGED]: mouseChanged,
  [Types.RESET]: reset
})



// WEBPACK FOOTER //
// ./src/redux/mouseRedux.js